import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'schedule-type-pill',
  templateUrl: './schedule-type-pill.component.html',
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class ScheduleTypePillComponent {
  @Input() scheduleTypeName: string = '';
  @Input() shape: 'pill' | 'square' = 'pill';
} 